import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ThemeOptionInput } from 'src/app/core/services/modules/environment-theme.service';

@Component({
  selector: 'app-dialog-platform-color',
  templateUrl: './dialog-platform-color.component.html',
  styleUrls: ['./dialog-platform-color.component.scss']
})
export class DialogPlatformColorComponent implements OnInit {

  themeData: ThemeOptionInput = {
    Name: '',
    PrimaryColor: '#039be5',
    SecondaryColor: '#5bb6e4'
  };
  isEdit = false;
  errorMsg = '';

  constructor(
    public dialogRef: MatDialogRef<DialogPlatformColorComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { 
    if (data && data.theme) {
      this.isEdit = true;
      let secondary = data.theme.SecondaryColor || null;
      if (!secondary || secondary.toUpperCase() === '#309ACF' || data.theme.PrimaryColor?.toUpperCase() === '#039BE5') {
        secondary = '#5bb6e4';
      }
      this.themeData = {
        Name: data.theme.Name,
        PrimaryColor: data.theme.PrimaryColor,
        SecondaryColor: secondary
      };
    }
  }

  ngOnInit(): void {
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onUpdate(): void {
    this.errorMsg = '';
    if (!this.themeData.Name || this.themeData.Name.trim() === '') {
      this.errorMsg = 'El nombre es requerido';
      return;
    }
    
    const output: ThemeOptionInput = {
      Name: this.themeData.Name.trim(),
      PrimaryColor: this.themeData.PrimaryColor.toUpperCase(),
      SecondaryColor: this.themeData.SecondaryColor ? this.themeData.SecondaryColor.toUpperCase() : null
    };

    this.dialogRef.close(output);
  }
}
